import {HprimFaxDto} from "@resources/resources";
import {Component, Input} from "@angular/core";

@Component({
  selector: 'dialog-hprim-rappel',
  templateUrl: './dialog-hprim-rappel.component.html'
})
export class HprimRappelComponent {

  @Input() dossier: HprimFaxDto;
  @Input() reemissionType: string;
  @Input() isConnectValue: boolean;
  @Input() traitementHprimFinished: boolean;

  isSuccess: boolean;
  isError: boolean;
  isInprogress: boolean;
  isWarn: boolean;

  constructor() {

  }

  ngDoCheck() {
    this.isInprogress = (this.dossier.etat == 'EN_COURS') || !this.dossier.etat;
    this.isSuccess = (this.dossier.etat == 'TERMINE') || (this.dossier.etat == 'TERMINE_EN_COURS');
    this.isError = !(this.isSuccess || this.isInprogress);
    this.isWarn = false;
  }

  ngAfterViewInit() {
    this.dossier.etat = null;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/common/utils/dialog/dialog-hprim-rappel/dialog-hprim-rappel.component.ts